import { requestService } from 'shared/utils/services/requestService';

export const startSession = async () => {
  return requestService({
    url: `/session`,
    method: 'GET',
  });
};
